import { createContext } from "react";

export const CardListContext = createContext();

export default CardListContext;
